import { GridColumn, } from "@progress/kendo-react-grid";
import { FilterDescriptor, SortDescriptor } from "@progress/kendo-data-query";
import { useNavigate } from "react-router-dom";
import { protectedResources } from '../../authConfig';
import { BaseGrid, ButtonHelper } from '../../components/KendoGrid/BaseGrid';
import { ActiveCell, FacilityNameCell } from '../../components/KendoGrid/SharedCells';
import { ActiveFilter } from '../../components/KendoGrid/ActiveFilter';

interface OperatorListProps {
    labId?: number,
    children?: React.ReactNode
}

const OperatorList = (props: OperatorListProps) => {
    const navigate = useNavigate();

    const alphabeticalSort = [{
        field: "OperatorName",
        dir: "asc"
    } as SortDescriptor];

    const gridFilter = props.labId ? [{
        field: "LabId",
        operator: "eq",
        value: props.labId,
    }] as FilterDescriptor[] : undefined;

    return (
        <BaseGrid filter={gridFilter} intialSort={alphabeticalSort} verb={'POST'} pageTitle='Operator List' endpoint={protectedResources.apiOperator.endpoint + "KendoGridRead"} redirectUrl="/operator-manage/"
            button={[{ onClick: () => { { navigate("/operator-manage"); } }, buttonText: 'Create New Operator' } as ButtonHelper]} excelFunction={(operator: any) => {
                const op = { ...operator };
                const inactive = operator.inactiveDate
                if (op.inactiveDate !== undefined) {
                    op.inactiveDate = inactive ? "Inactive" : "Active"
                }

                return op
            }}>
            <GridColumn field="operatorName" title="Operator Name" />
            <GridColumn field="department" title="Department" />
            {!props.labId &&
                <GridColumn field="lab.facilityName" cell={FacilityNameCell} title="Facility Name" />}
            <GridColumn field="title" title="Title" />
            <GridColumn field="email" title="Email" />
            <GridColumn field="inactiveDate" title="Active" cell={ActiveCell} filterCell={ActiveFilter} />
        </BaseGrid>
    );
}
export default OperatorList;